import { CategoryOption } from '@/ui/components/pages/products/types/CategoryOption';

export function extractCategories(components: any[]): CategoryOption[] {
  const categoryComponents = components.flatMap((comp: any) =>
    comp.content?.chunks?.flatMap((chunk: any[]) => chunk.flatMap((item: any) => {
      if (item.id === 'category') {
        return item.content?.options || [];
      }
      return [];
    })));
  return categoryComponents.flat();
}
